// iterationSteering.js — F13-E14-T03 + E15-T04: o ponto ÚNICO de re-steering
// por iteração (padrão long_conversation_reminder do Fable 5: lembretes TIPADOS
// anexados como mensagem do USER, "siga se relevante, senão continue").
// @arch:pure-engine
//
//   1. doom-loop (E15-T04, Reflexion): 10+ iterações agindo sem editar numa
//      tarefa de entrega → re-plan forçado, 1x.
//   2. long-loop reminder (E14-T03): a cada 12 iterações, re-ancora a TAREFA
//      ORIGINAL + o digest dos gates — combate o drift de sessão longa sem
//      re-injetar a constituição inteira.

import { doomLoopTripped } from './loopHealth.js';
import { REPLAN_NUDGE, PLAN_CONVERGE_NUDGE, NUDGE_MARKER } from '../codeAgentMode.js';

// Dogfood 2026-07-10 — freio do PLAN MODE: depois de K iterações de exploração a
// deliberação tem que CONSOLIDAR (present_plan), não ler mais um arquivo. Reusa o
// one-shot replanNudged (mesmo orçamento de 1 re-steering forte por run).
export const PLAN_CONVERGE_AFTER = 8;

/** True quando a deliberação de plano passou do ponto de consolidar (1x por run). */
export function planConvergenceTripped(s, { planMode = false } = {}) {
  return planMode && s.iteration >= PLAN_CONVERGE_AFTER && s.executedAnyTool;
}

/** A cada N iterações o lembrete de sessão longa re-ancora a tarefa. */
export const REMINDER_EVERY = 12;

/** True quando a iteração corrente deve receber o lembrete (1x por marco). */
export function longLoopReminderDue(s) {
  return s.iteration > 0
    && s.iteration % REMINDER_EVERY === 0
    && s.lastReminderIteration !== s.iteration;
}

/** O lembrete tipado: tarefa original + digest dos gates (não a LEI inteira). */
export function buildLongLoopReminder(taskText, iteration) {
  const task = String(taskText || '').trim().slice(0, 300);
  return [
    `${NUDGE_MARKER} LEMBRETE de sessão longa (iteração ${iteration}) — siga se relevante, senão continue normalmente.`,
    task ? `A tarefa ORIGINAL é: "${task}". Se você derivou pra sub-objetivos, volte a ela.` : '',
    'Os gates seguem valendo: done exige verificação RODADA neste turno; afirmar ação sem a tool correspondente é MENTIR; ambiente quebrado se conserta via run_command.',
  ].filter(Boolean).join(' ');
}

/**
 * Decide o re-steering desta iteração (ordem: doom-loop vence o lembrete).
 * Devolve { event, message } pro spine aplicar, ou null.
 * @param {import('./loopRunState.js').SpineState} s
 * @param {{ readOnly?: boolean, planMode?: boolean, isConversationalTask?: boolean, taskText?: string }} ctx
 */
export function iterationSteering(s, { readOnly = false, planMode = false, isConversationalTask = false, taskText = '' } = {}) {
  if (!s.replanNudged && doomLoopTripped(s, { readOnly, planMode, isConversationalTask })) {
    return { event: { type: 'nudge', which: 'replan' }, message: REPLAN_NUDGE };
  }
  if (!s.replanNudged && planConvergenceTripped(s, { planMode })) {
    return { event: { type: 'nudge', which: 'replan' }, message: PLAN_CONVERGE_NUDGE };
  }
  if (longLoopReminderDue(s)) {
    return { event: { type: 'reminder_tick' }, message: buildLongLoopReminder(taskText, s.iteration) };
  }
  return null;
}
